import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import {
  BusinessUnitIntegrationSetting,
  IntegrationSettings,
  useUpdateIntegrationSettings,
} from '@xemplo/business-unit-query';
import { safeCallAsync } from '@xemplo/safe-call';
import { ToastType, useToast } from '@xemplo/toast';

import { IntegrationSettingsFormValues } from '../business-unit-settings.types';

type UseEditSettingsModalProps = {
  businessUnitId: string;
  settings: IntegrationSettings;
  originalRows: BusinessUnitIntegrationSetting[];
  onClose: () => void;
};

export const useEditSettingsModal = ({
  businessUnitId,
  settings,
  originalRows,
  onClose,
}: UseEditSettingsModalProps) => {
  const { addToast } = useToast();
  const methods = useForm<IntegrationSettingsFormValues>({ defaultValues: settings });
  const { mutateAsync } = useUpdateIntegrationSettings({ businessUnitId });

  const { isDirty } = methods.formState;

  const handleClose = useCallback(() => {
    onClose();
    methods.reset();
  }, [onClose, methods]);

  const handleSubmit = methods.handleSubmit(async (values) => {
    const [, error] = await safeCallAsync(mutateAsync({ values, originalRows }));
    if (error) return;

    addToast({ text: 'Settings updated', type: ToastType.Confirmation });
    handleClose();
  });

  return { methods, handleSubmit, handleClose, isDirty };
};
